const NotFound = (props)=>{
  return (<h1>404.. This page is not found!</h1>);
};
export default NotFound;